import { apiSlice } from '../../api/apiSlice';

export const assessmentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    validateChangeMode: builder.mutation({
      query: (options) => ({
        url: 'Assessment/ValidateChangeMode',
        method: 'POST',
        body: options
      })
    }),
    changeAssessmentMode: builder.mutation({
      query: (options) => ({
        url: 'Assessment/ChangeMode',
        method: 'PUT',
        credentials: 'include',
        body: options
      })
    }),
    hideAssessments: builder.mutation({
      query: (options) => ({
        url: 'Assessment/Hide',
        method: 'PUT',
        credentials: 'include',
        body: options.assessmentIds
      })
    }),
    getAssessmentLinks: builder.query({
      query: () => ({
        url: 'Assessment/Links',
        method: 'GET'
      })
    }),
    isAssessmentAvailable: builder.mutation({
      query: () => ({
        url: 'Assessment/CheckIsAnyAssessment',
        method: 'GET',
        credentials: 'include'
      })
    }),
    getAssessments: builder.mutation({
      query: (options) => ({
        url: `Assessment/${options.skip}/${options.take}/?${options.params}`,
        method: 'GET',
        credentials: 'include',
      })
    }),
    getGradeAssessmentsCount: builder.mutation({
      query: () => ({
        url: 'Assessment/GradedCount',
        method: 'GET',
        credentials: 'include',
      })
    }),
    getGradeAssessments: builder.mutation({
      query: () => ({
        url: 'Assessment/Graded',
        method: 'GET',
        credentials: 'include',
      })
    }),
    getCRQuestions: builder.mutation({
      query: (option) => ({
        url: `Assessment/${option.assessmentId}/CRQuestions`,
        method: 'GET',
        credentials: 'include',
      })
    }),
    getUngradedSessions: builder.mutation({
      query: (option) => ({
        url: `Assessment/${option.assessmentId}/UnGradedSessions?questionId=${option.questionId}&courseId=${option.courseId}`,
        method: 'GET',
        credentials: 'include',
      })
    }),
    getChartData: builder.mutation({
      query: (option) => ({
        url: `Assessment/${option.assessmentId}/GradeInfo?questionId=${option.questionId}&courseId=${option.courseId}`,
        method: 'GET',
        credentials: 'include',
      })
    }),
    getRecentGrades: builder.mutation({
      query: (option) => ({
        url: `Assessment/${option.assessmentId}/RecentGrades?questionId=${option.questionId}&courseId=${option.courseId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    revokeGrade: builder.mutation({
      query: (option) => ({
        url: `Assessment/RevokeGrade?questionId=${option.questionId}&courseId=${option.courseId}&sessionId=${option.sessionId}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getCRAnswer: builder.mutation({
      query: (option) => ({
        url: `Question/${option.questionId}/CRAnswer?courseId=${option.courseId}&sessionId=${option.sessionId}&studentId=${option.studentId}`,
        method: 'GET',
        credentials: 'include'
      })
    })
  })
});

export const {
  useValidateChangeModeMutation,
  useChangeAssessmentModeMutation,
  useHideAssessmentsMutation,
  useLazyGetAssessmentLinksQuery,
  useGetAssessmentsMutation,
  useIsAssessmentAvailableMutation,
  useGetGradeAssessmentsCountMutation,
  useGetGradeAssessmentsMutation,
  useGetCRQuestionsMutation,
  useGetUngradedSessionsMutation,
  useGetChartDataMutation,
  useGetRecentGradesMutation,
  useGetCRAnswerMutation,
  useRevokeGradeMutation
} = assessmentApi;
